import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';

import { PartialResponse } from '../portal/domain/partialResponseDTO';
import { AppConfigService } from './appconfigservice';
@Injectable({
  providedIn: 'root',
})
export class JsonHelperService {
  private http = inject(HttpClient);

  private readonly baseUrl: string;
  constructor() {
    const appConfigService = inject(AppConfigService);

    this.baseUrl = appConfigService.baseUrl;
  }

  fullUrl(path: string) {
    return `${this.baseUrl}${path}`;
  }

  postJson<T extends PartialResponse>(url: string, body: any) {
    const hdrs = new HttpHeaders({
      'content-type': 'application/json',
      accept: 'application/json',
    });

    return this.http.post<T>(url, body, {
      headers: hdrs,
    });
  }

  postJsonAcceptImageBlob(url: string, body: any) {
    const hdrs = new HttpHeaders({
      'content-type': 'application/json',
      accept: 'image/png',
    });

    return this.http.post(url, body, {
      headers: hdrs,
      responseType: 'blob',
    });
  }

  postJsonAcceptsBlob(url: string, body: any) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });

    return this.http.post(url, body, {
      headers: headers,
      responseType: 'blob',
    });
  }
}
